import React from 'react';
import Content from '../../../components/Pages/FinancialInstitution/AccountsSummary';
import FinancialInstitutionLayout from '../../../components/Layout/FinancialInstitution';

function AccountsSummary() {
  document.title = 'Financial Institution: Accounts Summary';

  return (
    <FinancialInstitutionLayout childrenCentered>
      <Content />
    </FinancialInstitutionLayout>
  );
}

export default AccountsSummary;
